import axios from 'axios';

export const ROLE_SWITCH_CONTEXT_KEY = 'allureRoleSwitchContext';

export const getRoleSwitchContext = () => {
  try {
    return JSON.parse(sessionStorage.getItem(ROLE_SWITCH_CONTEXT_KEY) || 'null');
  } catch {
    return null;
  }
};

export const saveRoleSwitchContext = (context) => {
  sessionStorage.setItem(ROLE_SWITCH_CONTEXT_KEY, JSON.stringify(context));
};

export const clearRoleSwitchContext = () => {
  sessionStorage.removeItem(ROLE_SWITCH_CONTEXT_KEY);
};

export const getRoleLandingPath = (role) => {
  if (role === 'host') {
    return '/host/active-qr';
  }
  if (role === 'venue_owner') {
    return '/venue/analytics';
  }
  if (role === 'venue_member' || role === 'staff') {
    return '/staff-app/scan';
  }
  if (role === 'admin') {
    return '/admin';
  }
  return '/guest/home';
};

/**
 * Switch role + navigate to a specific venue entry picked from the merged
 * venue-switcher dropdown (top-left, in either the owner app or the staff
 * app). Unlike the plain in-app `switchVenue()` (which just swaps the
 * active id among venues already in the CURRENT scope, no reload needed),
 * this crosses from owner<->staff: it swaps the JWT role token via
 * `/auth/switch-role`, then does a full navigation so the destination app
 * tree mounts a fresh `VenueProvider` with the correct `scope`. Throws on
 * failure — callers should catch and toast.
 */
export const crossAppSwitchVenue = async (venue) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const API = `${BACKEND_URL}/api`;
  const token = localStorage.getItem('token');
  const isStaffVenue = Boolean(venue.staff_role);
  const targetRole = isStaffVenue ? 'venue_member' : 'venue_owner';

  const res = await axios.post(
    `${API}/auth/switch-role`,
    { target_role: targetRole },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  localStorage.setItem('token', res.data.access_token);
  localStorage.setItem('user', JSON.stringify(res.data.user));
  localStorage.setItem('activeVenueAppId', venue.id);

  const landing = isStaffVenue
    ? (venue.staff_role === 'admin' ? '/staff-admin/scan' : '/staff-app/scan')
    : '/venue/analytics';
  window.location.href = landing;
};